<template>
  <div :class="['sidescroller', videoSlider ? '' : 'imageSlider']">
    <template v-for="(imgSrc, index) in images">
      <video v-if="checkVideoExt(imgSrc)" controls :key="imgSrc + index" preload="metadata" >
        <source :src="imgSrc" type="video/mp4" />
      </video>
      <img v-else :key="imgSrc + index" :src="imgSrc" alt />
    </template>
  </div>
</template>

<script>
// import { lerp } from '@/assets/scripts/utils'
export default {
  name: 'SideScroller',
  props: {
    images: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      vScroll: 0,
      videoSlider: true
    }
  },
  methods: {
    // animate() {
    //   const lerped = lerp(this.$el.scrollLeft, this.vScroll, 0.1)
    //   this.$el.querySelectorAll('img').forEach(img => {
    //     img.style.transform = `skewX(${(this.$el.scrollLeft - lerped) / -2}deg)`
    //   })
    //   this.$el.scrollLeft = lerped
    //   if (!this.$store.state.user.hasTouch) {
    //     requestAnimationFrame(this.animate)
    //   }
    // },
    checkVideoExt(input) {
      const checker = /([a-zA-Z0-9\s_\\.\-:])+(.mp4)$/i
      this.videoSlider = checker.test(input)
      return checker.test(input)
    }
  },
  mounted() {
    // if (!this.videoSlider) {
    //   this.$el.addEventListener('mousemove', e => {
    //     const vMarginRatio = 0.5
    //     const vWidth = this.$el.clientWidth * vMarginRatio
    //     const vMargin = this.$el.clientWidth * (1 - vMarginRatio)
    //     const preVScroll =
    //       ((e.clientX - vMargin) / vWidth) *
    //       (this.$el.scrollWidth - vWidth / vMarginRatio)
    //     this.vScroll = Math.min(
    //       Math.max(0, preVScroll),
    //       this.$el.scrollWidth - vWidth / vMarginRatio
    //     )
    //   })
    // this.animate()
    // }
  }
}
</script>

<style lang="scss" scoped>
.sidescroller {
  overflow-y: hidden;
  overflow-x: scroll;
  white-space: nowrap;

  img,
  video {
    opacity: 1;
    margin-left: 1rem;
    outline: none;
    display: inline-block;
  }

  video {
    width: 90%;
    height: 100%;
  }

  img:first-of-type,
  video:first-of-type {
    margin-left: 0rem;
  }

  img {
    height: 100%;
  }
}

.imageSlider {
  cursor: ew-resize;
  height: 25rem;
}
</style>
